module.exports = __webpack_public_path__ + "media/images/plus-85a2d1bdd9bdc183bdfccb121ced5f8f.svg";